import type { OrderItem } from "./types";
import { itemKey } from "@/core/options/fingerprint";
import { MAX_CART_QUANTITY } from "./constants";

/**
 * Сколько единиц ещё влезает в корзину.
 *
 * `excludeKey` — позиция, количество которой сейчас правят: её текущий вклад
 * из суммы вычитается, иначе «+» на строке с 900 штуками гас бы из-за самой
 * этой строки.
 *
 * Закрывает 400 (потолок списка и суммы по нему): Σ по любому подсписку не
 * превосходит Σ по корзине. Потолок ИТОГА заказа (422) этим не закрыт —
 * считает ли домен брутто или нетто, из схемы не следует.
 */
export function remainingCartQuantity(
  items: readonly OrderItem[],
  excludeKey?: string,
): number {
  const used = items.reduce(
    (sum, i) =>
      excludeKey !== undefined && itemKey(i) === excludeKey ? sum : sum + i.quantity,
    0,
  );
  return Math.max(0, MAX_CART_QUANTITY - used);
}
